import type React from 'react';
import { useIsStagingOrDevOrLocal } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';
import { pushSSRFailureDisplay } from './ssr-failure-display/server-to-client.tsx';
import type { SSRFailureProps } from './types.tsx';

/**
 * A declarative component that taints a given location as a "fallback"
 * used to detect SSR success rate and the completeness of the page.
 */
export const FallbackIndicator: React.FC<SSRFailureProps> = ({
	reportToSlackChannel,
	fallbackId,
	displayErrorInStaging,
	isCookieCircuitBreakerFailure,
	cookieKey,
}) => {
	const isStagingOrDevOrLocal = useIsStagingOrDevOrLocal();
	if (__SERVER__) {
		if (displayErrorInStaging && isStagingOrDevOrLocal) {
			pushSSRFailureDisplay({
				reportToSlackChannel,
				fallbackId,
				displayErrorInStaging,
				isCookieCircuitBreakerFailure,
				cookieKey,
			});
		}
	}
	return null;
};

FallbackIndicator.displayName = 'FallbackIndicator';
